module.exports = __webpack_public_path__ + "static/1187994030-wide.25dddf73.jpg";